
import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import PageLoader from '../../components/common/pageLoader';
import TimetableCalender from '../../components/common/timetableCalendar';
import { getAirlines } from '../../services/airlines';
import { getCurrentUser } from '../../services/auth';
import { getHotelById } from '../../services/hotels';
import { getDestinationsByHotelUser } from '../../services/shuttleDestinations';

const BookShuttleLayoverPage = () => {

    const [isLoading, setIsLoading] = useState(true)
    const [hasSelectedDestination, setHasSelectedDestination] = useState(false)
    const [destination, setDestination] = useState()

    const [hotel, setHotel] = useState()
    const [airline, setAirline] = useState()

    const _currentUser = getCurrentUser();

    useEffect(() => {
        fetchHotel()
        fetchDestinations()
        fetchAirlines()
    }, [])

    const fetchAirlines = async () => {
        setIsLoading(true)
        const { data: { message } } = await getAirlines()
        setIsLoading(false)
        if (Array.isArray(message)) {
            let _airline = message.find(x => x.name.toLowerCase().includes('swiss'))
            setAirline(_airline)
        }
    }

    const fetchDestinations = async () => {
        const { data: { code, message } } = await getDestinationsByHotelUser(_currentUser.hotel_id)
        if (code === 200) {
            let _destination = message.find(x => x.destination === "Zurich Airport")
            setDestination(_destination)
        } else {
            //TODO: toast
        }
    }

    const fetchHotel = async () => {
        setIsLoading(true)
        const { data: { message } } = await getHotelById(_currentUser.hotel_id);
        setHotel(message);
        setIsLoading(false)
    }

    return <>
        {isLoading && <PageLoader />}
        {!isLoading && destination && hotel && airline &&
            <section>
                <Col>
                    {/* COMMENT OUT SELECT AIRLINE PRIOR TO TIMETABLE */}
                    {/* <> 
                        {!hasSelectedDestination ?
                            <>
                                {(_currentUser.role_name === "hotel-admin" || _currentUser.role_name === "hotel-staff") &&
                                    <>
                                        <AirlineDestinations setAirline={setAirline} selectDestination={selectDestination} />
                                    </>
                                }
                            </>
                            :
                            <>
                                <TimetableCalender destination={destination} hotel={hotel} airline={airline} />
                            </>
                        }
                    </> */}
                    <TimetableCalender destination={destination} hotel={hotel} airline={airline} />
                </Col>
            </section>
        }
    </>
}

export default BookShuttleLayoverPage
